<template>
  <div class="Jurisdiction">
    <el-dialog
      title="常用功能"
      width="1000px"
      append-to-body
      :visible.sync="visible"
      @close="clearData"
      :show="show"
      :close-on-click-modal="false"
    >
      <div class="Jurisdiction_one">
        <div class="Jurisdiction_tow">
          <div class="Jurisdiction_top">
            <div class="Jurisdiction_top_box">
              <div v-for="(item, index) in component" :key="index">
                <p>{{item.text}}</p>
                <ul>
                  <li v-for="(items, indexs) in item.textlist" :key="indexs">
                    <el-checkbox
                      @change="clickcheckbox($event,items)"
                      v-model="items.Show"
                      :label="items.title"
                      border
                    ></el-checkbox>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="Jurisdiction_bottom">
            <h3 style="padding: 10px 0 0 10px;">常用功能</h3>
            <div class="Jurisdiction_bottom_list">
              <ul>
                <li :index="(index + 1) + ''" v-for="(obj, index) in Commonlyused" :key="index">
                  <img :src="require('../../../assets/icon/'+obj.img)" alt />
                  <p>{{ obj.title }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: flex-end;">
        <el-button type="primary" size="mini" style="display:block" @click="saveGoods">确定</el-button>
        <el-button style="display:block" size="mini" @click="$emit('update:show', false)">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool"; //本地缓存存取
export default {
  data() {
    return {
      visible: this.show, //是否显示选择弹出框
      Commonlyused: [
        // {
        //   append: "",
        //   component: "saleorder",
        //   icon: "el-icon-star-on",
        //   img: "sale/order.png",
        //   menuId: "1",
        //   query: {},
        //   title: "销售订单",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "salesrelease",
        //   icon: "el-icon-star-on",
        //   img: "sale/order.png",
        //   menuId: "2",
        //   query: {},
        //   title: "销售出库",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "history",
        //   icon: "el-icon-star-on",
        //   img: "data/warehouse_information.png",
        //   menuId: "3",
        //   query: {},
        //   title: "仓库",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "company",
        //   icon: "el-icon-star-on",
        //   img: "data/customer.png",
        //   menuId: "4",
        //   query: {},
        //   title: "客户",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "businessprocess",
        //   icon: "el-icon-star-on",
        //   img: "report/business_process.png",
        //   menuId: "5",
        //   query: {},
        //   title: "经营历程",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "procurementorder",
        //   icon: "el-icon-star-on",
        //   img: "procurement/procurementorder.png",
        //   menuId: "6",
        //   query: {},
        //   title: "采购订单",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "procurementsrelease",
        //   icon: "el-icon-star-on",
        //   img: "procurement/purchasereceipt.png",
        //   menuId: "7",
        //   query: {},
        //   title: "采购入库",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "draftbusiness",
        //   icon: "el-icon-star-on",
        //   img: "report/draft_business.png",
        //   menuId: "8",
        //   query: {},
        //   title: "业务草稿",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "voucherorder",
        //   icon: "el-icon-star-on",
        //   img: "money/shoufu1.png",
        //   menuId: "9",
        //   query: {},
        //   title: "收款单",
        //   show: true
        // },
        // {
        //   append: "",
        //   component: "paymentorder",
        //   icon: "el-icon-star-on",
        //   img: "money/shoufu2.png",
        //   menuId: "10",
        //   query: {},
        //   title: "付款单",
        //   show: true
        // }
      ],
      Mode: [
        {
          title: "销售管理",
          component: "SaleModel"
        },
        {
          title: "仓库管理",
          component: "Warehouse"
        },
        {
          title: "采购管理",
          component: "Procurement"
        },
        {
          title: "资金管理",
          component: "MoneyModule"
        },
        {
          title: "报表管理",
          component: "ReportModel"
        },
        {
          title: "基础资料",
          component: "material"
        },
        {
          title: "系统设置",
          component: "Setup"
        }
      ],
      component: [
        // {
        //   text: "批发业务",
        //   img: "wholesale.png",
        //   textlist: [
        //     {
        //       icon: "el-icon-star-on",
        //       img: "sale/order.png",
        //       append: "",
        //       title: "销售订单",
        //       component: "saleorder",
        //       menuId: "1-1",
        //       query: [],
        //       show: true
        //     },
        //     {
        //       icon: "el-icon-star-on",
        //       img: "sale/order.png",
        //       title: "销售出库单",
        //       append: "",
        //       menuId: "1-2",
        //       component: "salesrelease",
        //       query: [],
        //       show: true
        //     },
        //     {
        //       icon: "el-icon-star-on",
        //       img: "sale/returnorder.png",
        //       title: "销售退货单",
        //       append: "",
        //       menuId: "1-3",
        //       component: "salereturn",
        //       query: [],
        //       show: true
        //     }
        //   ]
        // }
      ]
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    },
    visible: {
      handler(e, v) {
        if (e) {
          this.Commonlyused = this.$attrs.Commonlyused;
          this.Navigation();
        }
      }
    }
  },
  methods: {
    saveGoods() {
      this.$emit("saveGoods", this.Commonlyused);
      this.visible = false;
    },
    clickcheckbox(event, row) {
      if (event) {
        if (this.Commonlyused.length >= 10) {
          tool.popMessage(this, "最多可添加十个常用功能");
          row.Show = false;
          // this.component.forEach((item, index) => {});
        } else {
          let jparams = {
            user_id: tool.getLocal("userid"), //用户id
            session_id: tool.getLocal("sessionid"),
            all_data: this.component
          };
          this.request
            .post("/index/Person/update_user_fast_menu", {
              jparams: JSON.stringify(jparams)
            })
            .then(res => {
              // console.log(res);
              // let { status, choose_data, all_data } = res;
            });

          this.Commonlyused.push(row);
        }
      } else {
        this.Commonlyused.forEach((item, index) => {
          if (item.component == row.component) {
            // 删除选中的常用功能
            this.Commonlyused.splice(index, 1);
          }
        });
        let jparams = {
          user_id: tool.getLocal("userid"), //用户id
          session_id: tool.getLocal("sessionid"),
          all_data: this.component
        };
        this.request
          .post("/index/Person/update_user_fast_menu", {
            jparams: JSON.stringify(jparams)
          })
          .then(res => {
            // console.log(res);
            // let { status, choose_data, all_data } = res;
          });
      }
    },
    Navigation() {
      // this.Mode.filter(item => {
      let jparams = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid")
      };
      this.request
        .post("/index/Person/get_user_fast_menu", {
          jparams: JSON.stringify(jparams)
        })
        .then(res => {
          let { status, choose_data, all_data } = res;
          // console.log(Priv);
          this.component = all_data;
          this.Commonlyused = choose_data;
        });
      // });
    },
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.Jurisdiction_one {
  width: 100%;
  height: 500px;
  // overflow: hidden;
  .Jurisdiction_tow {
    width: 100%;
    height: 100%;
    // overflow: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    .Jurisdiction_top {
      width: calc(96% - 20px);
      height: 200px;
      // background-color: rgb(163, 231, 84);
      margin-top: 3px;
      box-shadow: 0px 0px 7px #ccc;
      padding: 10px 10px;
      overflow: hidden;
      .Jurisdiction_top_box {
        width: 100%;
        height: 100%;
        overflow: auto;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          list-style: none;
          width: 140px;
          height: 30px;
          margin: 5px;
          .el-checkbox.is-bordered.el-checkbox--medium {
            padding: 4px 15px 7px 10px;
            width: 140px;
            height: 28px;
          }
        }
      }
    }
    .Jurisdiction_bottom {
      width: 96%;
      height: 200px;
      background-color: #fff;
      margin-top: 3px;
      box-shadow: 0px 0px 7px #ccc;
      .Jurisdiction_bottom_list {
        height: calc(100% - 31px);
        ul {
          height: 175px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;

          li {
            list-style: none;
            width: 8%;
            text-align: center;

            img {
              width: 75%;
              height: 52%;
            }

            p {
              font-size: x-small;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/Jurisdiction/Jurisdiction.vue